import { JSX } from "react";
import { View, Text } from "react-native";
import { useGetCurrentUserQuery } from "@/_store/currentUser/currentUser.slice";
import { useGetFullMonitoringInfoQuery } from "@/_store/monitoringSubscription/monitoring.slice";
import Tabs, { TabsItem } from "@/app/components/Tabs";
import { useTabs } from "@/_hooks/useTabs";
import { PREVIOUS_TAB, UPCOMING_TAB } from "@/_utils/contstans";
import RevisionBlockWithDivider from "@/app/components/RevisionBlockWithDivider";
import SuccessIcon from "@/assets/icons/main/greenAlert.svg"
import SearchNotFound from "@/assets/icons/main/searchNotFound.svg"
import Skeleton from "@/app/components/Skeleton";
import Container from "@/app/components/Container";
import { EdgeInsets, useSafeAreaInsets } from "react-native-safe-area-context";

export interface IRevision {
  startDate?: string;
  endDate?: string;
  organ: string;
  title: string;
  next_check: boolean;
}

const SubscriptionAnalytics = (): JSX.Element => {
  const { data: currentUser } = useGetCurrentUserQuery();

  const subscriptionId: string | undefined = currentUser?.subscription?.id;
  const insets: EdgeInsets = useSafeAreaInsets();

  const { data: fullMonitoringData, isFetching } = useGetFullMonitoringInfoQuery(
    { id: subscriptionId! },
    { skip: !subscriptionId }
  );

  const futureRevisions: IRevision[] = fullMonitoringData?.upcoming_revisions ?? [];
  const pastRevisions: IRevision[] = fullMonitoringData?.current_revisions ?? [];

  const tabs: TabsItem[] = [
    {
      key: UPCOMING_TAB,
      label: "Предстоящие проверки",
      children: (
        <RevisionBlockWithDivider
          revisions={futureRevisions}
          icon={<SuccessIcon />}
          emptyMessage="В ближайшее время проверки не запланированы"
        />
      )
    },
    {
      key: PREVIOUS_TAB,
      label: "Прошедшие",
      children: (
        <RevisionBlockWithDivider
          revisions={pastRevisions}
          icon={<SearchNotFound />}
          emptyMessage="Проверки не найдены"
        />
      ),
    },
  ];

  const { activeTab, handleTabChange } = useTabs({
    items: tabs
  });

  return (
    <Container style={{  height: 100, flexGrow: 1,  paddingBottom: insets.bottom + 100 }} className="flex-1 m-5">
      <Text className="text-2xl text-black font-medium mb-3">{isFetching ? <Skeleton /> : fullMonitoringData?.name || "Нет информации"}</Text>
      <Text className="text-base text-gray mb-6">Отслеживаем все планируемые и не более 5 прошедших проверок</Text>
      <Tabs
        items={tabs}
        defaultActiveKey={activeTab}
        onChange={handleTabChange}
      />
    </Container>
  );
};

export default SubscriptionAnalytics;